module.exports = __webpack_public_path__ + "static/media/tomatillo.80033152.jpg";